export default "__VITE_ASSET__DRx2jnha__"